import { useMemo } from 'react';
import { filterData } from './util.js';

var useFilteredCollection = function (collection, filters, filtersDataMap) {
    return useMemo(function () {
        return ((collection === null || collection === void 0 ? void 0 : collection.filter(function (data) {
            var values = filtersDataMap ? filtersDataMap(data) : data;
            return filters === null || filters === void 0 ? void 0 : filters.every(function (filter) {
                if (!values.hasOwnProperty(filter.id))
                    return true;
                var value = values[filter.id];
                return Array.isArray(value)
                    ? value.some(function (v) { return filterData(filter, v); })
                    : filterData(filter, value);
            });
        })) || []);
    }, [collection, filters, filtersDataMap]);
};

export { useFilteredCollection };
